import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'practice-template/:id/clone',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/CloneTemplateContainer',
      './modules/CloneTemplate'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const CloneTemplate = require('./containers/CloneTemplateContainer').default
      const actions = require('./modules/CloneTemplate')
      const reducer = require('./modules/CloneTemplate').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'CloneTemplate', reducer: reducer })

      store.dispatch(actions.initialize())
    //   store.dispatch(actions.fetchFeatures())
      store.dispatch(actions.fetchPracticeTemplate(nextState.params.id))
      /*  Return getComponent   */
      cb(null, CloneTemplate)

      /* Webpack named bundle   */
    }, 'CloneTemplate')
  }
})



// WEBPACK FOOTER //
// ./src/routes/CloneTemplate/index.js